/* Lavi MD Creams theme JS */
(function () {
  const money = (cents) => {
    const fmt = document.body.dataset.moneyFormat || '${{amount}}';
    const val = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, val).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  /* Mobile nav */
  const nav = document.querySelector('.mobile-nav');
  document.querySelectorAll('[data-menu-open]').forEach(b => b.addEventListener('click', () => nav && nav.classList.add('is-open')));
  document.querySelectorAll('[data-menu-close]').forEach(b => b.addEventListener('click', () => nav && nav.classList.remove('is-open')));

  /* Cart drawer */
  const drawer = document.getElementById('CartDrawer');
  const openDrawer = () => { if (!drawer) return; drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
  const closeDrawer = () => { if (!drawer) return; drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
  document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', (e) => { if (drawer) { e.preventDefault(); refreshDrawer().then(openDrawer); } }));
  document.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  async function refreshDrawer() {
    if (!drawer) return;
    const res = await fetch('/?sections=cart-drawer');
    const json = await res.json();
    const tmp = document.createElement('div');
    tmp.innerHTML = json['cart-drawer'];
    const fresh = tmp.querySelector('#CartDrawer');
    if (fresh) { drawer.innerHTML = fresh.innerHTML; bindDrawer(); }
    updateCount();
  }
  async function updateCount() {
    const res = await fetch('/cart.js'); const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
  }
  function bindDrawer() {
    if (!drawer) return;
    drawer.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', closeDrawer));
    drawer.querySelectorAll('[data-line-remove]').forEach(b => b.addEventListener('click', async () => {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.lineRemove, quantity: 0 }) });
      refreshDrawer();
    }));
    drawer.querySelectorAll('[data-line-qty]').forEach(wrap => {
      const input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(btn => btn.addEventListener('click', async () => {
        const q = Math.max(0, parseInt(input.value || '0', 10) + parseInt(btn.dataset.delta, 10));
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: wrap.dataset.lineQty, quantity: q }) });
        refreshDrawer();
      }));
    });
  }
  bindDrawer();
  window.lmdCart = { refresh: refreshDrawer, open: openDrawer, close: closeDrawer };

  /* Product forms (AJAX add) */
  document.querySelectorAll('form[data-product-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      if (!drawer || document.body.dataset.cartDrawer !== 'true') return;
      e.preventDefault();
      const btn = form.querySelector('[type=submit]');
      const label = btn.querySelector('span') || btn;
      const orig = label.textContent;
      btn.disabled = true; label.textContent = btn.dataset.adding || 'Adding...';
      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('add failed');
        await refreshDrawer(); openDrawer();
      } catch (err) { form.submit(); }
      btn.disabled = false; label.textContent = orig;
    });
  });

  /* Quick add buttons (data-quick-add="variantId"), delegated so drawer upsells work after refresh */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]'); if (!btn) return;
    e.preventDefault();
    const label = btn.textContent; btn.disabled = true; btn.textContent = btn.dataset.adding || 'Adding...';
    await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: btn.dataset.quickAdd, quantity: 1 }) });
    await refreshDrawer(); if (drawer) openDrawer(); else window.location.href = '/cart';
    btn.disabled = false; btn.textContent = label;
  });

  /* Collection: shop by goal filter */
  const goalGrid = document.querySelector('[data-goal-grid]');
  if (goalGrid) {
    const empty = document.querySelector('.goal-nav__empty');
    document.querySelectorAll('[data-goal]').forEach(b => { if (!b.classList.contains('card')) b.addEventListener('click', () => {
      const goal = b.dataset.goal; let visible = 0;
      document.querySelectorAll('.goal-nav__btn').forEach(x => x.classList.toggle('is-active', x.dataset.goal === goal));
      goalGrid.querySelectorAll('.card').forEach(c => { const show = !goal || c.dataset.goal === goal; c.hidden = !show; if (show) visible++; });
      if (empty) empty.hidden = visible > 0;
    }); });
  }

  /* Buy more save more tiers */
  document.querySelectorAll('[data-qty-breaks]').forEach(wrap => {
    const root = wrap.closest('[data-product-root]') || document;
    const qtyInput = root.querySelector('input[name="quantity"]');
    const atc = root.querySelector('[data-atc]');
    wrap.querySelectorAll('input[name="qty_break"]').forEach(r => r.addEventListener('change', () => {
      const q = parseInt(r.value, 10);
      if (qtyInput) { qtyInput.value = q; }
      if (atc && !atc.disabled) { const l = atc.querySelector('span') || atc; l.textContent = q > 1 ? 'Add ' + q + ' to cart' : (atc.dataset.add || 'Add to cart'); }
    }));
  });
  window.lmdUpdateTiers = function (priceCents) {
    document.querySelectorAll('[data-qb-price]').forEach(el => {
      const q = parseInt(el.dataset.qbPrice, 10), pct = parseInt(el.dataset.qbPct || '0', 10);
      const full = priceCents * q, disc = Math.round(full * (100 - pct) / 100);
      el.innerHTML = money(disc) + (pct ? '<s>' + money(full) + '</s>' : '');
    });
  };

  /* Quantity steppers on product page */
  document.querySelectorAll('.qty[data-qty]').forEach(wrap => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(b => b.addEventListener('click', () => { input.value = Math.max(1, parseInt(input.value || '1', 10) + parseInt(b.dataset.delta, 10)); }));
  });

  /* Variant selection */
  document.querySelectorAll('[data-product-json]').forEach(script => {
    const product = JSON.parse(script.textContent);
    const root = script.closest('[data-product-root]');
    if (!root) return;
    const idInput = root.querySelector('input[name="id"]');
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare]');
    const atc = root.querySelector('[data-atc]');
    const sticky = document.querySelector('.sticky-atc');
    const opts = root.querySelectorAll('.variant-picker input[type=radio]');
    function current() {
      const sel = [];
      root.querySelectorAll('.variant-picker fieldset').forEach(fs => { const c = fs.querySelector('input:checked'); if (c) sel.push(c.value); });
      return product.variants.find(v => v.options.every((o, i) => o === sel[i])) || product.variants[0];
    }
    function update() {
      const v = current(); if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (window.lmdUpdateTiers) window.lmdUpdateTiers(v.price);
      if (compareEl) { if (v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; } else compareEl.hidden = true; }
      const saveEl = document.querySelector('[data-save]'), noteEl = document.querySelector('[data-price-note]');
      if (saveEl) { if (v.compare_at_price > v.price) { const d = v.compare_at_price - v.price; saveEl.textContent = 'You save ' + money(d) + ' (' + Math.round(d * 100 / v.compare_at_price) + '%)'; saveEl.hidden = false; if (noteEl) noteEl.hidden = false; } else { saveEl.hidden = true; if (noteEl) noteEl.hidden = true; } }
      if (atc) { const l = atc.querySelector('span') || atc; if (!v.available) { atc.disabled = true; l.textContent = atc.dataset.soldOut || 'Sold out'; } else { atc.disabled = false; l.textContent = atc.dataset.add || 'Add to cart'; } }
      if (sticky) { const sp = sticky.querySelector('[data-sticky-price]'); if (sp) sp.textContent = money(v.price); const sc = sticky.querySelector('[data-sticky-compare]'); if (sc) { if (v.compare_at_price > v.price) { sc.textContent = money(v.compare_at_price); sc.hidden = false; } else sc.hidden = true; } const sb = sticky.querySelector('[data-quick-add]'); if (sb) sb.dataset.quickAdd = v.id; }
      if (v.featured_image) { const main = document.querySelector('.gallery__main img'); if (main) main.src = v.featured_image.src; }
      const url = new URL(window.location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
    opts.forEach(o => o.addEventListener('change', update));
  });

  /* Gallery thumbs */
  document.querySelectorAll('.gallery__thumb').forEach(t => t.addEventListener('click', () => {
    const main = document.querySelector('.gallery__main img');
    if (main) { main.src = t.dataset.src; main.srcset = ''; }
    document.querySelectorAll('.gallery__thumb').forEach(x => x.classList.remove('is-active')); t.classList.add('is-active');
  }));

  /* Sticky ATC visibility */
  const sticky = document.querySelector('.sticky-atc');
  const buyRow = document.querySelector('.buy-row');
  if (sticky && buyRow && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => { sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); }, { threshold: 0 }).observe(buyRow);
  }
})();
